<template>
   <div>
        <div>
            <v-row :class="['d-flex', 'justify-center']">
                <!-- needleTransitionDuration=0 removes needle animation
                forceRender=true fixes bug where changing state resets needle to zero  -->
                <vue-speedometer ref="risq"
                class="pt-10 d-flex justify-center"
                id="risq-gauge"
                :maxValue="5"
                :value="score('total')"
                :currentValueText="`ICE Climate Risk Score: ${score('total')}`"
                :width="gaugeDimensions.risq.width"
                :height="gaugeDimensions.risq.height"
                :ringWidth="parentIsCusipSearchResult? 60 : 40"
                :segmentColors="segmentColors('total')"
                :customSegmentStops="customSegmentStops('total')"
                :customSegmentLabels="customSegmentLabels('total')"
                :needleTransitionDuration="0"
                :forceRender="true"
                :needleHeightRatio="parentIsCusipSearchResult? 0.7 : 0.5"
                :needleColor="needleColor"
                />
            </v-row>

            <v-row :class="['d-flex', 'justify-center']">
                <div v-for="scoreType in mainThreeCategories" v-bind:key="scoreType">
                    <vue-speedometer
                    :id="`${scoreType}-gauge`"
                    :maxValue="5"
                    :value="score(scoreType)"
                    :currentValueText="`${getCategoryLabel(scoreType)}: ${score(scoreType)}`"
                    :paddingVertical="paddingVertical(scoreType)"
                    :width="gaugeDimensions[scoreType].width"
                    :height="gaugeDimensions[scoreType].height"
                    :ringWidth="parentIsCusipSearchResult? 25 : 15"
                    :needleHeightRatio="parentIsCusipSearchResult? 0.5 : 0.4"
                    :segmentColors="segmentColors(scoreType)"
                    :customSegmentStops="customSegmentStops(scoreType)"
                    :customSegmentLabels="customSegmentLabels(scoreType)"
                    :needleTransitionDuration="0"
                    :forceRender="true"
                    :needleColor="needleColor"
                    />
                </div>
            </v-row>
        </div>

        <div v-if="parentIsCusipSearchResult" class="d-flex justify-center" >
            <v-btn
            class="mt-5"
            outlined
            color="info"
            @click="openDialog()"
            >
            <div>

                <div>Explore</div>
                 <div>
                 Climate Metrics
                 </div>
            </div>
            </v-btn>
        </div>

    <v-dialog @click:outside="showDialog = false" :value="showDialog"  scrollable v-if="parentIsCusipSearchResult">
        <v-card>
            <!-- putting mdi-close icon inside v-card-title in a scrollable v-dialog is what makes it sticky -->
            <v-card-title style="height: 0;" class="pa-0">
                <v-spacer></v-spacer>
                <v-btn icon @click="showDialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <!-- scrollable v-dialog expects text to be inside v-card-text, otherwise the text overflows the v-card -->
            <v-card-text class="pa-5">
                <div class="d-flex">
                    <v-btn
                    icon
                    :href="climateScoresUrl"
                    >
                        <v-icon color="info">
                            mdi-information
                        </v-icon>
                    </v-btn>
                    <div class="text-h4">
                    Climate Scores
                    </div>

                </div>
                <div class="d-flex">
                    <v-col cols="4" :class="['d-flex','align-center', 'flex-column']">
                        <!-- needleTransitionDuration=0 removes needle animation
                        forceRender=true fixes bug where changing state resets needle to zero  -->
                        <vue-speedometer
                        :maxValue="5"
                        :value="score('total')"
                        :currentValueText="`ICE Climate Risk Score: ${score('total')}`"
                        :width="200"
                        :height="150"
                        :ringWidth="40"
                        :segmentColors="segmentColors('total')"
                        :customSegmentStops="customSegmentStops('total')"
                        :customSegmentLabels="customSegmentLabels('total')"
                        :needleTransitionDuration="0"
                        :forceRender="true"
                        :needleHeightRatio="0.7"
                        :needleColor="needleColor"
                        />


                        <BarChart v-if="showThresholds"
                        :style="{
                            width:'100%',
                            height: '200px',
                            paddingLeft: '2px'
                        }"
                        :chart-data="{
                            labels: ['ICE Climate Risk Score'],
                            datasets: upbChartDatasets()
                        }"
                        :chart-options="upbChartOptions(true, true, 50)"
                        />
                    </v-col>


                    <v-col :class="['d-flex', 'flex-column']" cols="8">
                        <v-row v-for="scoreType in mainThreeCategories" v-bind:key="scoreType" >
                            <v-col cols="4" class="d-flex justify-end    align-center">
                                <vue-speedometer
                                :maxValue="5"
                                :value="score(scoreType)"
                                :currentValueText="`${getCategoryLabel(scoreType)}: ${score(scoreType)}`"
                                :width="150"
                                :height="120"
                                :ringWidth="35"
                                :segmentColors="segmentColors(scoreType)"
                                :customSegmentStops="customSegmentStops(scoreType)"
                                :customSegmentLabels="customSegmentLabels(scoreType)"
                                :needleTransitionDuration="0"
                                :forceRender="true"
                                :needleHeightRatio="0.5"
                                :needleColor="needleColor"
                                />
                            </v-col>

                            <v-col cols="7" class="d-flex justify-center align-center">
                                <BarChart v-if="showThresholds"
                                :style="{width: '90%', height: '100%'}"
                                :chart-data="{
                                    labels: [`${upbChartLabel(scoreType)} Score`],
                                    datasets: upbChartDatasets(scoreType)
                                }"
                                :chart-options="upbChartOptions(scoreType === 'hurricane', scoreType === 'wildfire', upbChartPadding, true)"
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                </div>

                <v-divider>
                </v-divider>

                <div class="d-flex align-center">
                    <v-btn
                    icon
                    href="https://docs.level11analytics.com/f_env_risk.html#value-at-risk-metrics"
                    >
                        <v-icon color="info">
                            mdi-information
                        </v-icon>
                    </v-btn>

                    <v-card-title class="text-h4 pl-0">
                        Value at Risk
                    </v-card-title>
                </div>

                <v-row class="d-flex align-end justify-center">
                    <v-col :cols="lineChartCols">
                        <div class="d-flex align-center justify-center">
                            <label class="v-label mr-2 theme--light">
                                RCP 4.5
                            </label>
                            <v-switch
                            v-model="eightFive"
                            label="RCP 8.5"
                            ></v-switch>
                        </div>
                        <LineChart
                        :style="{width: '90%'}"
                        :chart-options="perilChartOptions"
                        :chart-data="{
                            datasets: perilChartDatasets
                        }"
                        />
                    </v-col>

                    <v-col :cols="lineChartCols">
                        <LineChart
                        id="rcp-chart"
                        :style="{width: '90%'}"
                        :chart-data="{
                            labels: years,
                            datasets: rcpChartDatasets
                        }"
                        :chart-options="rcpChartOptions"
                        />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Line as LineChart, Bar as BarChart } from 'vue-chartjs/legacy'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  Filler,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
} from "chart.js";

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    BarElement,
    Filler
);

import VueSpeedometer from 'vue-speedometer'
import chroma from 'chroma-js'
import { mapState } from 'vuex'
import {risQScores} from '@/utils/risq_score'
export default {
  data: () => ({
    needleColor: "rgb(102, 102, 102)",
    cohortColor: 'indigo',
    savedCollection: null,
    risQScores: risQScores,
    climateScoresUrl: 'https://docs.level11analytics.com/f_env_risk.html#risq-climate-scores',
    mainThreeCategories: ['hurricane', 'flood', 'wildfire'],
    categoryMetaData: [
        {name: 'risq', label: 'RisQ'},
        {name: 'hurricane', label: 'Hurricane'},
        {name: 'flood', label: 'Flood'},
        {name: 'wildfire', label: 'Wildfire'}
    ],
    perilMetaData:
      [
        {
            name:'hurricaneflood',
            label: 'Hurricane Flood',
            backgroundColor: '#454db0'
        },
        {
            name:'hurricanewind',
            label: 'Hurricane Wind',
            backgroundColor: '#767bb8'
        },
        {
            name: 'stormsurge',
            label: 'Storm Surge',
            backgroundColor: '#9195bd'
        },
        {
            name: 'inlandflood',
            label: 'Inland Flood',
            backgroundColor: '#80b7cf'
        },
        {
            name: 'coastalflood',
            label: 'Coastal Flood',
            backgroundColor: '#49aabf'
        },
        {
            name: 'wildfire',
            backgroundColor:
            '#f7d0b0',
            label: 'Wildfire'
        }
    ],
    eightFive: true,
    years: [0, 10, 30],
    showDialog: false,
  }),
  components: {
    VueSpeedometer,
    LineChart,
    BarChart
  },
  props: {
    rscores: Object,
    isCMBS: Boolean,
    parentIsCusipSearchResult: Boolean
  },
  methods: {
    generateUpbChartLabels() {
        let component = this;
        let colors = ['#dedcdc'].concat(component.defaultColorScale.slice(2));
        let texts = [`Score \u2264 3`, `3 < Score \u2264 4`, `4 < Score \u2264 4.5`, `4.5 \u2264 Score`]
        let labels = colors.map((color, index) => {
                return {fillStyle: color, text: texts[index], lineWidth: 0}
            })
        return labels

    },
    paddingVertical(scoreType) {
        return this.cohortScore(scoreType) !== null? 20 : 0 //need extra padding when there's a cohort score label
    },
    getCategoryLabel(category) {
        let metaData = this.categoryMetaData.find(entry => entry.name === category)
        return metaData.label
    },
    openDialog() {
        this.showDialog = true
    },
    concatenatePercent: function(TooltipItem) {
        let label = TooltipItem.dataset.label
        let value = TooltipItem.formattedValue
        return label.concat(': ').concat(value).concat('%')
    },
    upbChartOptions(displayLegend = true, displayTitle = true, padding = 5,  customLabels = false) {
       return  {
            layout: {
                //setting padding instead of setting width in style, because padding doesn't cut off chart tooltips
                padding: {
                    right: padding,
                    left: padding
                }
            },
            maintainAspectRatio: false,
            indexAxis:'y',
            scales:
            {
                y:
                {
                    stacked: true,
                    display: false
                },
                x:
                {
                    stacked: true,
                    max: 100
                },
            },
            plugins:
            {
                title:
                {
                    text: '% of UPB at high/extreme risk',
                    display: displayTitle,
                    position: 'bottom'
                },
                legend: {
                    display: displayLegend,
                    align: 'start',
                    labels: customLabels? {
                        generateLabels: this.generateUpbChartLabels,
                        font: {
                            size: this.upbChartFontSize
                            }
                    } :
                    {
                        font:{
                            size: this.upbChartFontSize,
                        },
                    },
                },
                tooltip: {
                    callbacks: {
                        label: this.concatenatePercent
                        }
                }


        }
       }
    },
   percentGteThreshold(threshold, category='risq') {
    return Number(Number.parseFloat(this.summary[`pct_${category}_score_gte_${threshold}`]).toFixed(1))
   },
   getLinearCoefficient(f0, f10) {
        return (f10 - f0)/10
   },
   extrapolateAtX(f0, f10, x) {
    return this.getLinearCoefficient(f0, f10)*x + f0
   },
   rcpChartColor(rcp) {
        return rcp === '85'? '#b34444' : '#4469b3'
        //rcp === '85'? '#292929' : '#919191'
    },
    rcpChartDataset(rcpType) {
        let dataset = {};
        let data = []
        this.years.forEach(year => {
            data.push(this.summaryForPerilRcpYear('combined', rcpType, year))
        })
        dataset = {
            data,
            label: rcpType === '45'? `RCP 4.5` : `RCP 8.5`, borderColor: this.rcpChartColor(rcpType),
            backgroundColor: this.rcpChartColor(rcpType)
        }
        return dataset
    },
    summaryForPerilRcpYear(peril, rcp, year) {
        //CMBS doesn't have combined in the database, so we have to compute it
        if(this.isCMBS && peril === 'combined') {
            return this.combinedRisk(rcp, year)
        }
        else {
            return this.summary[this.summaryKey(peril, rcp, year)]
        }
    },
    upbChartLabel(category) {
        let metaData = this.categoryMetaData.find(entry => entry.name === category)
        let label = metaData.label;
        return label
    },
    upbChartDatasets(category = 'risq') {

        //valid for [a,b] pairs among [0,30], [30,40], [40,45], [45-50]
        let percentBetweenThresholds = (a,b, category) => {
            //middle thresholds
            if(a === 30 || a === 40) {
                return this.percentGteThreshold(a, category) - this.percentGteThreshold(b, category)
            }
            //endpoint thresholds
            else if(a === 0) {
               return 100 - this.percentGteThreshold(30, category)
            }
            else {
                return this.percentGteThreshold(45, category)
            }
        }

        let values = []
        let thresholdPairs = [[0,30], [30,40], [40,45], [45,50]]
        let label = this.upbChartLabel(category)

        thresholdPairs.forEach(pair => {
            values.push(percentBetweenThresholds(pair[0], pair[1], category))
        })

        let colors = ['#dedcdc'].concat(this.defaultColorScale.slice(2))//pale grey for score <3.0, the high end of the default-color scale for other values
        let labels = [`${label} Score \u2264 3`, `3 < ${label} Score \u2264 4`, `4 < ${label} Score \u2264 4.5`, `4.5 \u2264 ${label} Score`]
        let datasets = values.map((value, index) => {
           return  {
            data: [value],
            backgroundColor: colors[index],
            label: labels[index],
            maxBarThickness: 25,
            }
        })
        return datasets
    },
    getPerilData(perilName) {
        let data = []
        let rcp = this.eightFive? '85' : '45'

            if(perilName !== 'coastalflood') {
                this.years.forEach(year => {
                    //the database has climate-conditioned values for years in [0, 10, 30]
                        data.push({x: year, y: this.summaryForPerilRcpYear(perilName, rcp, year)})

                })
            }
            //coastal flood isn't climate-conditioned and only has 0 and 10-year values
            else {
                let f0 = this.summaryForPerilRcpYear('coastalflood', '85', 0) //rcp = '45' would have worked just as well, for the coastalflood case this is just a dummy variable
                let f10 = this.summaryForPerilRcpYear('coastalflood', '85', 10);
                data.push({x: 0, y: f0});
                data.push({x:10, y: f10});
                data.push({x:30, y: this.extrapolateAtX(f0, f10, 30)})
            }
        return data
    },
    combinedRisk(rcp, year) {
        let sum = 0;
        this.perilMetaData.forEach(peril => {
            let name = peril.name;
            let value = this.summary[this.summaryKey(name, rcp, year)] //this doesn't extrapolate coastal flood values, just uses the 10-year value for higher years, which is the same definition as the one used in the database for non-cmbs securities
            sum += value;
        })
        return sum;
    },
    summaryKey: function(category, rcpType, returnPeriod) {
        if(this.isCMBS) {
             if(returnPeriod === 0) {
                if(category !== 'coastalflood') {
                    return `${category}_rcp${rcpType}_current`
                }
                else {
                    return 'coastalflood_base_current'
                }
            }
            else {
                if(category === 'coastalflood') {
                    return `${category}_base_${returnPeriod}yr`
                }
                else {
                    return `${category}_rcp${rcpType}_${returnPeriod}yr`
                }
            }
        }
        else {
            if(returnPeriod === 0) {
                return `${category}_totaldamage_fullbasis_base_current`
            }
            else {
                return category === 'coastalflood' ?
                    `${category}_totaldamage_fullbasis_base_${returnPeriod}yr` :
                    `${category}_totaldamage_fullbasis_rcp${rcpType}_${returnPeriod}yr`
            }
        }

    },
    score: function(scoreType) {
        return Number(this.rscores[scoreType])
    },
    cohortScore: function(scoreType) {
        if(this.isPTCore && this.summary['cohort_risq_score']!== null) {
            if(scoreType === 'total'){
                return Number(Number.parseFloat(this.summary['cohort_risq_score'].toFixed(1)))
            }
            else {
                return Number(Number.parseFloat(this.summary[`cohort_${scoreType}_score`]).toFixed(1))
            }
        }
        else {
            return null
        }

    },
    customSegmentStops: function(scoreType) {
        //add total score and cohort score to array from 0 to 5, then sort
        let result = [];
        for(let number = 0; number <= 5; number++){
            result.push(number)
        };
        let score = this.score(scoreType);
        let cohortScore = this.cohortScore(scoreType)
        result.push(score);

        //these will be the endpoints of dark grey line corresponding to cohort score
        if(cohortScore !== null) {
            result.push(cohortScore);
            result.push(cohortScore + 0.05)//we're drawing a thin segment of a circle (wedge) between values cohortScore and cohortScore + 0.05 to mimick a line
        }

        result = result.sort((a,b) => a - b);
        result = [...new Set(result)]//this gets all unique values, which makes the case where score or cohortScore are integers cleaner
        return result

    },
    customSegmentLabels: function(scoreType) {
        let defaultLabel = {text: null};
        let cohortLabel = {text: "Cohort", position: 'OUTSIDE', fontSize: 10, color: this.cohortColor}

        //labels go in the middle of the wedge, to the left of the given stop, hence we're taking the second endpoint of the mini-wedge corresponding to the cohort line
        let isCohortStop = (stop) => {
            return stop === this.cohortScore(scoreType) + 0.05
        }
        let nonZeroStops = this.customSegmentStops(scoreType).slice(1) //the array of labels has length 1 shorter than customSegmentStops because there's no label for zero
        let labels = nonZeroStops.map(stop => {
            return isCohortStop(stop)? cohortLabel : defaultLabel
        })
        return labels;
    },
     segmentColors: function(scoreType) {
        //take the five colors of the default scale, then insert the color corresponding to the total score at the appropriate index, then insert the color corresponding to the cohort score at the appropriate index, then insert dark grey for cohort score arrow, then turn everything on the scale that comes after the total score into pale grey

        let result = [...this.defaultColorScale] //making a copy of defaultColorScale so that we won't be changing the original when we splice

        let insertDefaultColorIntoResult = (score) => {
            let insertIndex = Math.floor(score);//the floor of the score is its index in the 5-point default color array
            let colorToInsert = this.defaultColorScale[insertIndex];
            //no color segments to add for whole number scores
            if(score !== insertIndex){
                result.splice(insertIndex, 0, colorToInsert)
           }
        };
        let score = this.score(scoreType);
        let cohortScore = this.cohortScore(scoreType);
        let segmentStops = this.customSegmentStops(scoreType);
        let cohortLineColor = this.cohortColor;

        //1. insert color corresponding to total score
        insertDefaultColorIntoResult(score);

        if(cohortScore !== null) {
            //2. insert color corresponding to cohort score
            insertDefaultColorIntoResult(cohortScore);

            let cohortLineColorInsertIndex = segmentStops.indexOf(cohortScore);
            //3. insert dark grey at cohort score index
            result.splice(cohortLineColorInsertIndex, 0, cohortLineColor)
        }

        let greyIndex = segmentStops.indexOf(score)
        let leftSlice = result.slice(0, greyIndex)  //everything to the left of greyIndex is <=totalScore, so should be left as is
        let rightSlice = result.slice(greyIndex)
        let isCohortLine = (color) => {
            return color === cohortLineColor //the 'colors' we're inserting into the result array are just strings, so it's fine to test for equality regardless of the format we've defined cohortLineColor in
            //this assumes no other colors in the array are cohortLineColor, but that's true
        }

        rightSlice = rightSlice.map(color => {
            return isCohortLine(color)? color : '#dedcdc' //map non-cohort-line to pale grey, leave cohort line as is
        });

    return leftSlice.concat(rightSlice)
  },
  gaugeUrls() {
        let dataUrlIntro = 'data:image/svg+xml;base64,'
        let categories = [...this.mainThreeCategories]
        categories.push('risq')
        let urls = {}
        categories.forEach(category => {
            let categoryId = `${category}-gauge`;
            let categorySelector = `#${categoryId} svg`;
            let gauge = document.querySelector(categorySelector)

            if(gauge !== null) {
                //the steps below are like .toDataUrl() but for svg elements
                gauge = new XMLSerializer().serializeToString(gauge)
                let dataUrl = dataUrlIntro.concat(window.btoa(gauge))
                urls[category] = dataUrl //now we have the url and are passing it to the urls object
            }
        })
        return urls
    },
  },
  computed: {
    gaugeDimensions() {
    let risqGaugeWidth = this.parentIsCusipSearchResult? 250 : 230
    let risqGaugeHeight= this.parentIsCusipSearchResult? 200 : 150
    let gaugeWidth = this.parentIsCusipSearchResult? 110: 105
    let gaugeHeight= this.parentIsCusipSearchResult? 110: 80
    let dimensions = {}
    dimensions['risq'] = {width: risqGaugeWidth, height: risqGaugeHeight}
    this.mainThreeCategories.forEach(category => dimensions[category] = {width: gaugeWidth, height: gaugeHeight})
    return dimensions
  },
    upbChartFontSize() {
        switch(this.$vuetify.breakpoint.name) {
            case 'xs': return 8
            case 'sm': return 8
            case 'md': return 10
            case 'lg': return 12
            case 'xl': return 14
        }
    },
    perilChartDatasets() {
        let datasets = []
        this.perilMetaData.forEach(peril => {
            datasets.push({
                label: peril.label,
                data: this.getPerilData(peril.name),
                fill: true,
                backgroundColor: peril.backgroundColor
            })
        })
    return datasets
    },
    perilChartOptions() {
        //we want the maximum of the chart to stay fixed when we toggle rcp value, so we need to calculate the maximum across the two charts
        //combined adds the 10-year coastal flood value to 30-year values for all perils, but the actual maximum on the chart extrapolates coastal flood to a 30-year value
        //so we're going to add that to combined to calculate the maximum, and subtract the 10-year coastal flood value
        //and then we'll add max/10 for a bit of padding
        //note that this breaks down if the VaRs decrease over time (by a substantial amount not handled by the padding)

        let coastalFloodData = this.getPerilData('coastalflood'); //coastal flood is not climate-conditioned so it doesn't matter that this.getPerilData is taking the selected rcp value
        let thirtyYearCoastalFloodObject = coastalFloodData.find(obj => obj.x === 30)
        let thirtyYearCoastalFlood = thirtyYearCoastalFloodObject.y

        let tenYearCoastalFloodObject = coastalFloodData.find(obj => obj.x === 10);
        let tenYearCoastalFlood = tenYearCoastalFloodObject.y

        let thirtyYearCombined = (rcp) => {
            return this.summaryForPerilRcpYear('combined', rcp, 30)
        }

        let maxForRcp = (rcp) => {
            return thirtyYearCoastalFlood + thirtyYearCombined(rcp) - tenYearCoastalFlood
        }
        let max = Math.max(maxForRcp('45'), maxForRcp('85'))

        //calculate step size by finding a nice number near max/8
        let stepSizes = [0.001, 0.01, 0.1, 1, 10, 0.05, 0.5, 5, 0.002, 0.02, 0.2, 2]//set of possible "nice" numbers
        stepSizes = stepSizes.sort((a, b) => a - b)
        let stepSize = max/8;
        stepSize = stepSizes.find((size, index) => {
            if(index !== 0){
                let prevSize = stepSizes[index - 1]
                return prevSize <= stepSize && stepSize < size
            }
            else {
                return stepSize <= size
            }
        })

        //maximum for the chart is the first multiple of stepSize greater than the maximum across the two rcp values
        let stepMultiplier = Math.ceil(max/stepSize)
        max = stepSize * stepMultiplier

        return ({
            scales:
            {
                yAxis:
                    {
                        stacked: true,
                        beginAtZero: true,
                        title: {
                            display: true,
                            text: 'VaR (%)'
                        },
                        stepSize: stepSize,
                        max: max
                    },
                xAxis:
                    {
                        type: 'linear',//this ensures that the distance between 10 and 30 is double the distance between 0 and 10
                        title:
                            {
                                display: true,
                                text: 'Years Forward'
                            }
                        }
            },
            plugins:
            {
                title:
                    {
                        display: true,
                        text: 'Value at Risk by Peril over Time'
                    },
            }
        })
    },
    rcpChartOptions() {
        return ({
            plugins:
            {
                title:
                {
                    text: 'Combined Risk',
                    display: true
                }
            },
                scales: {
                    yAxis:
                        {
                            beginAtZero: false,
                            title: {
                                display: true,
                                text: 'VaR (%)'
                                },

                        },
                    xAxis:
                        {
                            type: 'linear',//this ensures that the distance between 10 and 30 is double the distance between 0 and 10
                            title:
                                {
                                    display: true,
                                    text: 'Years Forward'
                                }
                        }
                }
             })
    },
    rcpChartDatasets: function() {
        let rcpTypes = ['45', '85']
        let datasets = []
        rcpTypes.forEach(rcpType => {
            datasets.push(this.rcpChartDataset(rcpType))
        })
        return datasets
    },
    upbChartPadding: function() {
        switch(this.$vuetify.breakpoint.name) {
            // case 'xl': return 180
            // case 'lg': return 70
            // case 'md': return 50
            // case 'sm': return 0
            default: return 20
        }
    },
    lineChartCols: function() {
        switch(this.$vuetify.breakpoint.name) {
            case 'xl': return 4
            default: return 6
        }
    },
    defaultColorScale: function() {
        return  chroma.bezier(['#fafa6e','#fc035e']).scale().gamma(1.3).colors(5)
    },
    showThresholds: function() {
      return Boolean(this.summary)
    },
    isPTCore: function() {
      return Boolean(this.summary && this.summary.isPTCore)
    },
    ...mapState({
      results: state => state.currentCusipData,
      summary: state => state.summaryData,
      powerpointData: state => state.powerpointData,
      startPowerpointGeneration: state => state.startPowerpointGeneration,
      powerpointDataToGenerate: state => state.powerpointDataToGenerate
    })
},
  watch: {
    startPowerpointGeneration(newVal) {
        if(newVal === true) {
            window.setTimeout(() => {
            let powerpointData = this.powerpointData
            powerpointData.rScore = this.rscores['total']
            powerpointData.gaugeUrls = this.gaugeUrls();//this is a method and not a computed property to force it to recompute every time
            //computed properties which are objects break in ways I don't completely understand
            powerpointData.gaugeDimensions = this.gaugeDimensions
            this.$store.dispatch('updateState', ['powerpointData', powerpointData])
            let powerpointDataToGenerate = this.powerpointDataToGenerate.filter(name => name !== 'gaugeUrls').filter(name => name !== 'gaugeDimensions')
            this.$store.dispatch('updateState', ['powerpointDataToGenerate', powerpointDataToGenerate]);
            },
            500)
        }
    }
  }
}
</script>
<style scoped>
.container {
  line-height: 1.4;
  text-align: center;
  padding: 44px;
  color: #333;
}

h1 {
  font-size: 50px;
}

p {
  font-size: 18px;
}
p small {
  font-size: 80%;
  color: #666;
}







.rscore, span.rscore {
    background: linear-gradient(321deg,rgba(0, 158, 216,1.0) 0%,rgba(83,201,0,1.0) 100%);
        -webkit-text-fill-color: transparent;
        -webkit-background-clip: text;
    font-weight: bold;
}
table td {
  padding-right: 5px;
  padding-left: 5px;
}
   .round{
        border-radius: 50%;
        /* text-align: right; */
    }

    .v-chip:hover::before {
    opacity: 0;

}

.v-chip{
     padding: 0;
}

</style>
<style>



table td.subscore {
  padding: 5px 10px;
}

table td.cohort {
  opacity: 0.55;
  line-height:1em
}
</style>
